import { render } from "./editEcogeste.vue?vue&type=template&id=aa28a15c&scoped=true"
import script from "./editEcogeste.vue?vue&type=script&lang=js"
export * from "./editEcogeste.vue?vue&type=script&lang=js"

import "./editEcogeste.vue?vue&type=style&index=0&id=aa28a15c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa28a15c"]])

export default __exports__